import AR from '../../public/locales/AgroLocationWeatherModal/es/ar/translations.json';
import BR from '../../public/locales/AgroLocationWeatherModal/pt/br/translations.json';
var translations = {
  AR: AR,
  BR: BR
};
export function getLanguage(country) {
  return translations[country];
}